import { Add, Delete, Edit, Visibility } from "@material-ui/icons";
import {
  Card,
  CardContent,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { NavLink, useLocation, useParams } from "react-router-dom";
import React, { createRef, useState } from "react";
import {
  deleteShipconfigService,
  fetchshipconfigService,
} from "../../../../services/shipConfigService";

import { Autocomplete } from "@material-ui/lab";
import CreateDialog from "./CreateDialog";
import CustomAlert from "../../../components/CustomAlert";
import CustomDeleteDialog from "../../../components/CustomDeleteDialog";
import CustomTable from "../../../../components/GovGrMaterialTable";
import { Helmet } from "react-helmet-async";
import UpdateDialog from "./UpdateDialog";
import { fetchPortAuthorities } from "../../../../services/portAuthoritiesService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import GovGrBreadcrumbs from "../../../../components/GovGrBreadCrumbs";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
  card: {
    marginTop: "1rem",
    marginBottom: "1.5rem",
  },
  applicationCard: {
    maxWidth: "80vw",
  },
});

const ShipConfig = () => {
  const { t } = useLocale();

  const classes = useStyles();
  let { id } = useParams();
  const search = useLocation().search;
  const shipId = new URLSearchParams(search).get("ship");
  const shipName = new URLSearchParams(search).get("shipname");
  const crewlist = new URLSearchParams(search).get("crewlist");

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);

  const [selectedItem, setSelectedItem] = useState({});
  const [isError, setIsError] = useState(false);

  const tableRef = createRef();
  const [portAuthId, setportAuthId] = useState(
    useSelector((state) => state?.authReducer?.user?.port_auth_id)
  );
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );

  const refreshTable = () => {
    refetch();
  };

  const { data: shipConfigs, refetch } = useQuery("shipConfigs", () =>
    fetchshipconfigService(id)
  );

  const { data: PortAuthorities } = useQuery(
    "portAuthorities",
    fetchPortAuthorities
  );

  return (
    <>
      <Helmet title={t("Ship Configuration")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Ship Configuration")}
      </Typography>
      <GovGrBreadcrumbs
        segments={[
          { href: "/", label: t("Dashboard") },
          {
            href: `/nauticalcrewlist/shipconfig/${id}?ship=${shipId}&shipname=${shipName}&crewlist=${crewlist}`,
            label: t("Nautical Crew List"),
          },
          { href: "/nauticalcrewlist/ship", label: t("Ships") },
          { href: `/nauticalcrewlist/ship/${shipId}`, label: shipName },
          {
            href: `/nauticalcrewlist/shiprecordhd/${crewlist}?shipname=${shipName}&ship=${shipId}`,
            label: t("Nautical Crew List") + crewlist,
          },
          {
            href: `#`,
            label: t("Ship Configuration"),
          },
        ]}
      />
      <Divider my={6} />

      {auth_level === 0 && PortAuthorities ? (
        <Card className={classes.card} elevation={3}>
          <CardContent className={classes.applicationCard}>
            <Autocomplete
              id="combo-box-demo"
              onChange={(event, newValue) => {
                setportAuthId(newValue?.id);
              }}
              options={PortAuthorities || []}
              getOptionLabel={(option) => option?.dscr}
              style={{ width: 300, marginTop: 10 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("Port Authorities")}
                  variant="outlined"
                />
              )}
            />
          </CardContent>
        </Card>
      ) : null}

      <CustomAlert
        open={isError}
        close={() => {
          // refetch();
        }}
        message={t("A network error occured, please try again later")}
      />
      <CustomTable
        // isLoading={isLoading}
        ref={tableRef}
        columns={[
          { field: "sc_id", title: "id" },
          { field: "s_dscr", title: t("Sector") },
          { field: "sp_name", title: t("Specialization") },
          { field: "sc_no", title: t("Count") },
          // { field: "modified_by", title: t("") },
          // { field: "modified_on", title: t("") },
        ]}
        data={shipConfigs?.rows || []}
        actions={[
          {
            icon: () => <Add />,
            tooltip: t("Add"),
            isFreeAction: true,
            onClick: () => {
              setIsCreateDialogOpen(true);
            },
          },
          {
            icon: () => <Edit style={{ color: "#1E90FF" }} />,
            tooltip: t("Edit"),
            onClick: (event, rowData) => {
              setIsUpdateDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
          {
            icon: () => <Delete style={{ color: "#B22222" }} />,
            tooltip: t("Delete"),
            onClick: (event, rowData) => {
              setIsDeleteDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
        ]}
      />
      <CreateDialog
        refreshTable={refreshTable}
        ship_record_hd_id={crewlist}
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
      />
      <UpdateDialog
        ship_record_hd_id={crewlist}
        open={isUpdateDialogOpen}
        refreshTable={refreshTable}
        close={() => setIsUpdateDialogOpen(false)}
        selectedItem={selectedItem}
      />
      <CustomDeleteDialog
        title={t("Delete Call Sign")}
        message={t("Are you sure you want to delete the selected item")}
        fieldName="sc_id"
        idFieldName="sc_id"
        refetch={refreshTable}
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        selectedItem={selectedItem}
        deleteService={deleteShipconfigService}
      />
    </>
  );
};

export default ShipConfig;
